module.exports = __webpack_public_path__ + "img/207-guam.58be541e.svg";